<div *ngIf="aberta" class="modal-backdrop-custom" (click)="fechar.emit()">
  <div class="modal-card modal-solicitacao-ferias" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h3 class="h5 mb-0">Solicitar férias</h3>
      <button type="button" class="btn btn-light btn-sm" (click)="fechar.emit()" aria-label="Fechar">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body-custom">
      <p class="text-secondary small mb-3">
        O pedido fica no nome do servidor, como no portal. Depois você defere ou indefere na lista.
      </p>

      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">Servidor</label>
          <app-busca-pesquisavel
            nomeCampo="buscaServidorFerias"
            rotuloBuscar="Pesquisar servidor"
            placeholder="Digite nome ou matrícula"
            [termo]="busca"
            (termoChange)="busca = $event"
            [itens]="funcionariosFiltrados"
            [rotuloItem]="rotuloServidor"
            [detalheItem]="detalheServidor"
            (selecionar)="selecionarServidor($event)">
          </app-busca-pesquisavel>
          <div class="form-text" *ngIf="servidorSelecionado">
            {{ servidorSelecionado.matricula }} · {{ servidorSelecionado.nome }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label" for="inicioFeriasAdmin">Início</label>
          <input class="form-control" id="inicioFeriasAdmin" type="date" name="inicioFeriasAdmin" [(ngModel)]="dataInicio" required>
        </div>
        <div class="col-md-6">
          <label class="form-label" for="fimFeriasAdmin">Fim</label>
          <input class="form-control" id="fimFeriasAdmin" type="date" name="fimFeriasAdmin" [(ngModel)]="dataFim" required>
        </div>
      </div>
    </div>

    <div class="modal-footer-custom">
      <button type="button" class="btn btn-outline-secondary" (click)="fechar.emit()" [disabled]="salvando">
        Cancelar
      </button>
      <button type="button" class="btn btn-success" [disabled]="!formularioValido || salvando" (click)="confirmar()">
        {{ salvando ? 'Enviando...' : 'Enviar solicitação' }}
      </button>
    </div>
  </div>
</div>
